import React from 'react';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import type { PreviewResult } from '../components/PreviewCommand/index.js';
import { PreviewCommand } from '../components/PreviewCommand/index.js';
import type { ProjectModel } from '../model.js';
import { log } from './logger.js';
import { executeCommand } from './execute-command.js';

export async function nonInteractivePreview(
  services: AstroCommandServices,
  model: ProjectModel,
  options: { baseUrl?: string; label?: string; previewId?: string }
) {
  const { baseUrl, label, previewId } = options;

  const { previewId: resultPreviewId, previewUrl } =
    await executeCommand<PreviewResult>(services, model, (resolve) => (
      <PreviewCommand
        baseUrl={baseUrl}
        previewId={previewId}
        onPreviewCreated={resolve}
        environment="preview"
        label={label}
      />
    ));

  log(JSON.stringify({ previewId: resultPreviewId, previewUrl }, null, 2));
}
